import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `AutoCompleteRoot`
};

export function useAutoCompleteStyles() {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          "& .ms-SearchBox-field::placeholder": {
            color: semanticColors.inputPlaceholderText
          }
        }
      ]
    }),
    [semanticColors]
  );
}
